<template>
    <div class="sermon-player" >
        <!-- regular video -->
        <video
            @load="posterLoaded"
            download
            :autoplay="this.autoplay"
            :muted="this.autoplay === 'muted'"
            preload="none"
            :poster="poster"
            :src="src"
            :live="live"
            :streamingid="streamingid"
            :streamingtitle="streamingtitle"
            :siteid="siteid"
            controls
            playsinline
            :ref="src"
            class="video-js vjs-fluid vjs-theme-fantasy"
            data-setup='{ "playbackRates": [0.5, 0.75, 1, 1.5, 1.75, 2] }'
        >
            <source :src=src >
        </video>
    </div>
</template>

<script>
import { trackPlayerEventsMixin } from '../../mixins/trackPlayerEventsMixin'
import { EventBus } from '../../mixins/EventBus';
import { attachId3CueReader } from '../../streaming/id3Cues';

export default {
    mixins: [trackPlayerEventsMixin],
    name: 'Video',
    props: ['autoplay', 'loop', 'poster', 'src','live','streamingid','streamingtitle','siteid'],
    data() {
        return {
            detachId3CueReader: null,
        }
    },
    mounted() {
        this.registerEvents()

        // Send the player object to the parent component
        EventBus.$emit('player', this.player);

        this.attachInbandCueReader();
    },
    watch: {
        src: function(newValue, oldValue) {
            this.registerEvents();
            if (newValue !== oldValue) {
                window.location.reload();
            }
        }
    },
    methods: {
        posterLoaded() {
            if (typeof window.sermonCloudResizeHeight == 'function') {
                window.sermonCloudResizeHeight()
            }
        },

        /**
         * Read the in-band ID3 control-plane cues (giving banner state, settings epoch, prompts)
         * from the live transport stream. Live players only — harvested VOD carries the original
         * ID3 and must never replay old operator actions.
         */
        attachInbandCueReader() {
            if (!this.live || !this.$store || !this.player) {
                return;
            }

            const store = this.$store;

            this.player.ready(() => {
                this.detachId3CueReader = attachId3CueReader(this.player, {
                    onState: (payload) => {
                        // Proven in-band signal: relax the settings poll to the safety cadence.
                        store.dispatch('streamSettings/setInbandActive', true);
                        store.dispatch('streamSettings/applyInbandState', payload);
                    },
                    onEvent: (payload) => {
                        store.dispatch('streamSettings/applyInbandEvent', payload);
                    },
                });
            });
        },
    },
    beforeDestroy() {
        if (this.detachId3CueReader) {
            this.detachId3CueReader();
            this.detachId3CueReader = null;
        }
        if (this.live && this.$store) {
            this.$store.dispatch('streamSettings/setInbandActive', false);
        }
    },
}
</script>
